import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  closeIcon: {
    width: 25,
    cursor: "pointer",
  },
  root: {
    bottom: 0,
    left: 0,
    minWidth: "100%",
    "& .MuiSnackbarContent-root": {
      width: "100%",
      background: "rgba(0,0,0,.8)",
      fontSize: "14px",
      letterSpacing: "0.5px",
      height: "54px",
      color: "#FFFFFF",
    },
  },
}));